import React from 'react';
import {
    Avatar,
    Button,
    Checkbox,
    CircularProgress,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    Divider,
    FormControl,
    FormControlLabel,
    FormHelperText,
    FormLabel,
    Grid,
    IconButton,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Paper,
    Radio,
    RadioGroup,
    Select,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField,
    Typography,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { withSnackbar } from 'notistack';
import GoogleMapReact from 'google-map-react';
import moment from 'moment-timezone';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import { DatePicker, DateTimePicker } from 'material-ui-pickers';
import { isEmpty } from 'lodash';
import EditIcon from '@material-ui/icons/Create';
import HybridTextField from '../hybridTextField';
import titalise from '../../utilities/titalise';
import {
    titles,
    counties,
    countries,
} from '../../utilities/menuOptions';
import Tile from '../../containers/tile';
import ContactHistory from './contactHistory';

const CustomTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
        whiteSpace: 'nowrap',
    },
}))(TableCell);

const styles = (theme) => ({
    row: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.background.default,
        },
    },
    tableHead: {
        fontWeight: 'bold',
        fontSize: 14,
    },
    paper: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        overflowX: 'auto',
        padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
    },
    tileBottomDivider: {
        marginTop: theme.spacing.unit * 3,
        // marginBottom: theme.spacing.unit * 2,
    },
    dialogDivider: {
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 3,
        marginLeft: -24,
        marginRight: -24,
    },
    bottomBarContainer: {
        width: '100%',
        textAlign: 'right',
    },
    textButton: {
        marginTop: theme.spacing.unit * 1.5,
        marginBottom: 0,
    },
    dialogActions: {
        marginRight: theme.spacing.unit * 2.5,
    },
    nameField: {
        width: 350,
    },
    addressField: {
        width: 250,
    },
    postcodeField: {
        width: 120,
    },
    countryField: {
        width: 200,
        marginLeft: theme.spacing.unit * 3,
    },
    emailField: {
        width: 350,
    },
    rightOfFieldButton: {
        marginTop: 10,
        marginLeft: theme.spacing.unit * 3,
        color: 'rgba(0, 121, 255, 0.87)',
    },
    dialogContentContainer: {
        marginTop: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 2,
    },
    dialogButton: {
        marginTop: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 1,
    },
    dialogContent: {
        paddingBottom: 0,
        minWidth: 600,
    },
    formHelperText: {
        color: '#f44336',
    },
    contactLocationIcon: {
        color: 'red',
        fontSize: 30,
        position: 'absolute',
        transform: 'translate(-50%, -100%)',
    },
    branchLocationIcon: {
        color: 'blue',
        fontSize: 30,
        position: 'absolute',
        transform: 'translate(-50%, -100%)',
    },
    progressContainer: {
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 3,
        width: 60,
    },
    progress: {
        opacity: '.5',
    },
    inputLabel: {
        backgroundColor: '#fff',
        paddingLeft: 8,
        marginLeft: -5,
        paddingRight: 8,
    },
    menuFormControl: {
        marginBottom: theme.spacing.unit * 1,
        marginTop: theme.spacing.unit * 2,
    },
    checkboxLabel: {
        fontSize: 16,
    },
    dialogAddButton: {
        textAlign: 'right',
    },
    dialogTitle: {
        marginBottom: 24,
    },
    // table: {
    //     width: '60%',
    // },
    fieldTitle: {
        color: 'rgba(0, 0, 0, 0.54)',
        fontSize: 11,
        fontWeight: 400,
        marginBottom: theme.spacing.unit * 1,
    },
    chip: {
        marginRight: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 2,
    },
    chipColumn: {
        alignItems: 'flex-start',
        display: 'flex',
        flexDirection: 'column',
    },
    chipsButton: {
        marginTop: 0,
        marginBottom: theme.spacing.unit * 2,
    },
});

class ContactEngineer extends React.Component {
    state = {
        addEngineerPostcodeZoneData: {
            engineerPostcodeZone: '',
        },
        addUnavailableVisitData: {
            adHocNote: '',
            points: '',
            scheduledVisitDateTime: '',
        },
        disableAddEngineerPostcodeZoneSaveButton: false,
        showAddEngineerPostcodeZoneDialog: false,
        showAddUnavailableVisitDialog: false,
    };

    componentDidMount() {
        this.setupFormData();
    }

    componentDidUpdate(prevProps) {
        if (this.props.contact !== prevProps.contact) {
            this.setupFormData();
        }
    }

    setupFormData() {
        if (this.props.contact) {
            // this.setState((state) => ({
            //     contactDebtData: {
            //         ...state.contactDebtData,
            //         companyReference: this.props.contact.debt ? this.props.contact.debt.companyReference : '',
            //         status: this.props.contact.debt ? this.props.contact.debt.status : '',
            //         type: this.props.contact.debt ? this.props.contact.debt.type : '',
            //         debtCompanyCode: this.props.contact.debt ? this.props.contact.debt.company.code : '',
            //         suspendCommunication: this.props.contact.debt ? this.props.contact.debt.suspendCommunication : '',
            //         startDate: this.props.contact.debt ? this.props.contact.debt.startDate : '',
            //         endDate: this.props.contact.debt ? this.props.contact.debt.endDate : '',
            //         note: this.props.contact.debt ? this.props.contact.debt.note : '',
            //     },
            // }));
        }
    }

    handleAddUnavailableVisitClick = () => {
        this.setState({
            showAddUnavailableVisitDialog: true,
        });
    };

    handleAddUnavailableVisitCloseDialogClick = () => {
        this.setState({
            showAddUnavailableVisitDialog: false,
        });
    };

    // handleEditContactDebtCheckBoxClick = (name) => (event) => {
    //     const newValue = this.state.contactDebtData[name] !== true;
    //     this.setState((state) => ({
    //         contactDebtData: {
    //             ...state.contactDebtData,
    //             [name]: newValue,
    //         },
    //     }));
    // };

    updateAddUnavailableVisitData = (event) => {
        const { name, value } = event.target;

        let formattedValue;
        switch (name) {
        default:
            formattedValue = value;
            break;
        }
        event.target.value = formattedValue;

        this.setState((state) => ({
            addUnavailableVisitData: {
                ...state.addUnavailableVisitData,
                [name]: formattedValue,
            },
        }));
    };

    // handleSaveContactDebtDetails = (event) => {
    //     event.preventDefault();
    //     this.setState({
    //         disableAddUnavailableVisitSaveButton: true,
    //     });
    //     this.props.saveContactDebtDetails(this.state.contactDebtData).then(() => {
    //         this.setState({
    //             showAddUnavailableVisitDialog: false,
    //             disableAddUnavailableVisitSaveButton: false,
    //         });
    //         this.props.enqueueSnackbar('Contact Debt Details Saved', { variant: 'success' });
    //     }).catch(() => {
    //         console.log(this.props.errors);
    //         this.props.enqueueSnackbar('Contact Debt Details Save Failed', { variant: 'error' });
    //         this.setState({
    //             disableAddUnavailableVisitSaveButton: false,
    //         });
    //     });
    // };

    // handleAddCompany = (event) => {
    //     event.preventDefault();
    //     this.setState({
    //         disableAddEngineerPostcodeZoneSaveButton: true,
    //     });
    //     this.props.addCompany(this.state.addCompanyData).then(() => {
    //         this.setState({
    //             showAddEngineerPostcodeZoneDialog: false,
    //             disableAddEngineerPostcodeZoneSaveButton: false,
    //         });
    //         this.props.enqueueSnackbar('New Debt Company Saved', { variant: 'success' });
    //     }).catch(() => {
    //         console.log(this.props.errors);
    //         this.props.enqueueSnackbar('New Debt Company Save Failed', { variant: 'error' });
    //         this.setState({
    //             disableAddEngineerPostcodeZoneSaveButton: false,
    //         });
    //     });
    // };

    handleScheduledVisitDateTimeChange = (chosenDate) => {
        this.setState((state) => ({
            addUnavailableVisitData: {
                ...state.addUnavailableVisitData,
                scheduledVisitDateTime: moment(chosenDate).format('YYYY-MM-DD'),
            },
        }));
    };

    // handleScheduledVisitEndDateTimeChange = (chosenDate) => {
    //     this.setState((state) => ({
    //         contactDebtData: {
    //             ...state.contactDebtData,
    //             endDate: moment(chosenDate).format('YYYY-MM-DD'),
    //         },
    //     }));
    // };

    // ***************

    handleAddEngineerPostcodeZoneClick = () => {
        this.setState({
            addEngineerPostcodeZoneData: {
                engineerPostcodeZone: '',
            },
            showAddEngineerPostcodeZoneDialog: true,
        });
    };

    handleAddEngineerPostcodeZoneCloseDialogClick = () => {
        this.setState({
            showAddEngineerPostcodeZoneDialog: false,
        });
    };

    handleDeleteEngineerUnavailableVisit = (visit) => {
        this.props.deleteEngineerUnavailableVisit(visit.code).then(() => {
            this.props.enqueueSnackbar('Engineer Unavailable Visit Deleted', { variant: 'success' });
        }).catch(() => {
            console.log(this.props.errors);
            this.props.enqueueSnackbar('Delete Engineer Unavailable Visit Failed', { variant: 'error' });
        });
    };

    handleDeleteEngineerPostcodeZone = (postcodeZoneCode) => {
        this.props.deleteEngineerPostcodeZone(postcodeZoneCode).then(() => {
            this.props.enqueueSnackbar('Engineer Postcode Zone Deleted', { variant: 'success' });
        }).catch(() => {
            console.log(this.props.errors);
            this.props.enqueueSnackbar('Delete Engineer Postcode Zone Failed', { variant: 'error' });
        });
    };

    updateAddEngineerPostcodeZoneData = (event) => {
        const { name, value } = event.target;

        let formattedValue;
        switch (name) {
        default:
            formattedValue = value;
            break;
        }
        event.target.value = formattedValue;

        this.setState((state) => ({
            addEngineerPostcodeZoneData: {
                ...state.addEngineerPostcodeZoneData,
                [name]: formattedValue,
            },
        }));
    };

    addEngineerPostcodeZone = (event) => {
        event.preventDefault();
        this.setState({
            disableAddEngineerPostcodeZoneSaveButton: true,
        });

        const selectedPostcodeZone = this.props.postcodeZones.find((postcodeZone) => postcodeZone.postcodeZone === this.state.addEngineerPostcodeZoneData.engineerPostcodeZone);

        this.props.addEngineerPostcodeZone(selectedPostcodeZone).then(() => {
            this.setState({
                disableAddEngineerPostcodeZoneSaveButton: false,
                showAddEngineerPostcodeZoneDialog: false,
            });
            this.props.enqueueSnackbar('New Engineer Postcode Zone Saved', { variant: 'success' });
        }).catch(() => {
            console.log(this.props.errors);
            this.props.enqueueSnackbar('New Engineer Postcode Zone Save Failed', { variant: 'error' });
            this.setState({
                disableAddEngineerPostcodeZoneSaveButton: false,
            });
        });
    };

    addEngineerUnavailableVisit = (event) => {
        event.preventDefault();
        this.setState({
            disableAddUnavailableVisitSaveButton: true,
        });

        this.props.addEngineerUnavailableVisit(this.state.addUnavailableVisitData).then(() => {
            this.setState({
                disableAddUnavailableVisitSaveButton: false,
                showAddUnavailableVisitDialog: false,
            });
            this.props.enqueueSnackbar('New Engineer Unavailable Visit Saved', { variant: 'success' });
        }).catch(() => {
            console.log(this.props.errors);
            this.props.enqueueSnackbar('New Engineer Unavailable Visit Save Failed', { variant: 'error' });
            this.setState({
                disableAddUnavailableVisitSaveButton: false,
            });
        });
    };

    render() {
        const {
            addNewHistoryNote,
            classes,
            contact,
            contactHistoriesLoading,
            contactLoading,
            errors,
            fetchContactData,
            fetchHistoriesData,
            postcodeZones,
        } = this.props;
        const {
            addEngineerPostcodeZoneData,
            disableAddEngineerPostcodeZoneSaveButton,
            disableAddUnavailableVisitSaveButton,
            showAddEngineerPostcodeZoneDialog,
            addUnavailableVisitData,
            showAddUnavailableVisitDialog,
        } = this.state;

        let currentEngineerHistories = null;
        if (!contactLoading && !contactHistoriesLoading) {
            currentEngineerHistories = contact.histories.filter((history) => history.entryType === 'ENGINEER');
        }

        const unavailableVisitMaxPoints = addUnavailableVisitData.scheduledVisitDateTime
            ? ((contact.contactEngineer.workingWeek.find((day) => day.weekDay === moment(addUnavailableVisitData.scheduledVisitDateTime).format('dddd').toUpperCase())) || {}).maxPoints || 0
            : 0;

        const postcodeZoneChips = Object.keys(contact.contactEngineer.postcodeZones || {}).map((key) => (
            <Chip
                key={key}
                label={contact.contactEngineer.postcodeZones[key].postcodeZone}
                onDelete={this.props.user.userScopes.includes('editEngineerPostcodeZones:*') ? () => this.handleDeleteEngineerPostcodeZone(contact.contactEngineer.postcodeZones[key].code) : null}
                className={classes.chip}
                color="secondary"
            />
        ));

        const overrideChips = Object.keys(contact.contactEngineer.unavailableVisits || {}).map((key) => (
            <Chip
                avatar={<Avatar>{contact.contactEngineer.unavailableVisits[key].points}</Avatar>}
                key={key}
                label={`${moment(contact.contactEngineer.unavailableVisits[key].scheduledVisitDateTime).format('Do MMMM YYYY')} (${contact.contactEngineer.unavailableVisits[key].adHocNote})`}
                onDelete={this.props.user.userScopes.includes('editEngineerUnavailableVisits:*') ? () => this.handleDeleteEngineerUnavailableVisit(contact.contactEngineer.unavailableVisits[key]) : null}
                className={classes.chip}
                color="secondary"
            />
        ));

        return (
            <>
                <Tile
                    tileTitle="Operative"
                    refreshAction={fetchContactData}
                    refreshing={contactLoading}
                    // tileMenuItems={[
                    //     {
                    //         action: this.handleContactDebtEditClick,
                    //         label: 'Edit Debt Detail',
                    //         section: 2,
                    //     },
                    // ]}
                    style
                >
                    { !contactLoading
                        ? (
                            <>
                                <Grid container spacing={0}>
                                    <Grid item xs={6}>
                                        <Grid item xs={12}>
                                            <HybridTextField
                                                label="Parent Branch"
                                                text={contact.contactEngineer.branch ? contact.contactEngineer.branch : ''}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <div className={classes.fieldTitle}>
                                                Postcode Zones
                                            </div>
                                            {postcodeZoneChips}
                                            <Button
                                                className={classes.chipsButton}
                                                type="submit"
                                                disabled={!this.props.user.userScopes.includes('editEngineerPostcodeZones:*')}
                                                onClick={this.handleAddEngineerPostcodeZoneClick}
                                            >
                                                ADD
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <HybridTextField
                                                label="Visit Types"
                                                text={[
                                                    contact.contactEngineer.delivery ? 'Delivery' : null,
                                                    contact.contactEngineer.installation ? 'Installation' : null,
                                                ].filter(Boolean).join(', ') || 'None'}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <HybridTextField
                                                label="Daily Target Amount"
                                                text={`£${contact.contactEngineer.targetDailyAmount ? contact.contactEngineer.targetDailyAmount.toFixed(2) : '0.00'}`}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <div className={classes.fieldTitle}>
                                                Unavailable Visits
                                            </div>
                                            <div className={classes.chipColumn}>
                                                {overrideChips}
                                                <Button
                                                    className={classes.chipsButton}
                                                    type="submit"
                                                    disabled={!this.props.user.userScopes.includes('editEngineerPostcodeZones:*')}
                                                    onClick={this.handleAddUnavailableVisitClick}
                                                >
                                                    ADD
                                                </Button>
                                            </div>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Paper>
                                            <Table className={classes.table} padding="dense">
                                                <TableHead>
                                                    <TableRow>
                                                        <CustomTableCell align="left">Day</CustomTableCell>
                                                        <CustomTableCell align="right">Default Points</CustomTableCell>
                                                        <CustomTableCell align="left">Product Types</CustomTableCell>
                                                        {this.props.user.userScopes.includes('HIDE:*') && (
                                                            <CustomTableCell align="left" />
                                                        )}
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {contact.contactEngineer.workingWeek.map((day, i) => {
                                                        i++;
                                                        return (
                                                            <TableRow className={classes.row} key={i}>
                                                                <CustomTableCell align="left">{day.weekDay}</CustomTableCell>
                                                                <CustomTableCell align="center">{day.maxPoints}</CustomTableCell>
                                                                <CustomTableCell align="center">{day.productTypes.join(', ')}</CustomTableCell>
                                                                {this.props.user.userScopes.includes('HIDE:*') && (
                                                                    <CustomTableCell align="center">
                                                                        {' '}
                                                                        <IconButton
                                                                            className={classes.button}
                                                                            onClick={() => this.updateEngineerWorkingWeek(day)}
                                                                        >
                                                                            <EditIcon />
                                                                        </IconButton>
                                                                    </CustomTableCell>
                                                                )}
                                                            </TableRow>
                                                        );
                                                    })}
                                                </TableBody>
                                            </Table>
                                        </Paper>
                                    </Grid>
                                </Grid>

                                <Dialog
                                    open={showAddUnavailableVisitDialog}
                                    onClose={this.handleAddUnavailableVisitCloseDialogClick}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                >
                                    <DialogContent className={classes.dialogContent}>
                                        <div className={classes.dialogContentContainer}>
                                            <>
                                                <Typography variant="h6" className={classes.dialogTitle}>
                                                    Unavailable Visit Details
                                                </Typography>
                                                <DatePicker
                                                    name="scheduledVisitDateTime"
                                                    id="scheduledVisitDateTime"
                                                    margin="normal"
                                                    label="Date"
                                                    value={addUnavailableVisitData.scheduledVisitDateTime ? moment(addUnavailableVisitData.scheduledVisitDateTime).format('YYYY-MM-DD') : null}
                                                    onChange={this.handleScheduledVisitDateTimeChange}
                                                    fullWidth
                                                    variant="outlined"
                                                    format="DD/MM/YYYY"
                                                    invalidLabel="None"
                                                    autoOk
                                                    minDate={new Date(moment().format('YYYY-MM-DD'))}
                                                />
                                                <Grid item xs={12}>
                                                    <FormControl
                                                        className={classes.menuFormControl}
                                                        variant="outlined"
                                                        fullWidth
                                                        required
                                                        error={!!errors.title}
                                                        disabled={!addUnavailableVisitData.scheduledVisitDateTime}
                                                    >
                                                        <InputLabel htmlFor="points" className={classes.inputLabel}>Points</InputLabel>
                                                        <Select
                                                            keyboard="true"
                                                            input={(
                                                                <OutlinedInput
                                                                    onChange={this.updateAddUnavailableVisitData}
                                                                    name="points"
                                                                    id="points"
                                                                />
                                                            )}
                                                            value={addUnavailableVisitData.points || ''}
                                                        >
                                                            <MenuItem value=""><em>None</em></MenuItem>
                                                            {Array.from({ length: unavailableVisitMaxPoints }, (_, index) => index + 1).map((point) => (
                                                                <MenuItem
                                                                    key={point}
                                                                    value={point}
                                                                >
                                                                    {point}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                        {errors.points && (
                                                            <FormHelperText>{errors.points}</FormHelperText>
                                                        )}
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <TextField
                                                        onChange={this.updateAddUnavailableVisitData}
                                                        className={classes.formControl}
                                                        name="adHocNote"
                                                        id="adHocNote"
                                                        value={addUnavailableVisitData.adHocNote || ''}
                                                        label="Reason for Unavailability"
                                                        margin="normal"
                                                        variant="outlined"
                                                        fullWidth
                                                        required
                                                        multiline
                                                        rows="1"
                                                        autoFocus
                                                    />
                                                </Grid>
                                                <Grid
                                                    container
                                                    spacing={0}
                                                    direction="column"
                                                    alignItems="center"
                                                    justify="center"
                                                >
                                                    <Grid item xs={12}>
                                                        <Button
                                                            className={classes.dialogButton}
                                                            type="submit"
                                                            disabled={disableAddUnavailableVisitSaveButton || !addUnavailableVisitData.adHocNote || !addUnavailableVisitData.scheduledVisitDateTime || !addUnavailableVisitData.points}
                                                            onClick={this.addEngineerUnavailableVisit}
                                                        >
                                                            SAVE
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </>
                                        </div>
                                    </DialogContent>
                                    <Divider />
                                    <DialogActions className={classes.dialogActions}>
                                        <Button
                                            onClick={this.handleAddUnavailableVisitCloseDialogClick}
                                            color="primary"
                                            autoFocus
                                        >
                                            Close
                                        </Button>
                                    </DialogActions>
                                </Dialog>

                                <Dialog
                                    open={showAddEngineerPostcodeZoneDialog}
                                    onClose={this.handleAddEngineerPostcodeZoneCloseDialogClick}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                >
                                    <DialogContent className={classes.dialogContent}>
                                        <div className={classes.dialogContentContainer}>
                                            <>
                                                <Typography variant="h6" className={classes.dialogTitle}>
                                                    Add Engineer Postcode Zone
                                                </Typography>
                                                <Grid item xs={12}>
                                                    <FormControl
                                                        className={classes.menuFormControl}
                                                        variant="outlined"
                                                        fullWidth
                                                        required
                                                        error={!!errors.engineerPostcodeZone}
                                                    >
                                                        <InputLabel htmlFor="engineerPostcodeZone" className={classes.inputLabel}>Postcode Zones</InputLabel>
                                                        <Select
                                                            keyboard="true"
                                                            input={(
                                                                <OutlinedInput
                                                                    onChange={this.updateAddEngineerPostcodeZoneData}
                                                                    name="engineerPostcodeZone"
                                                                    id="engineerPostcodeZone"
                                                                />
                                                            )}
                                                            value={addEngineerPostcodeZoneData.engineerPostcodeZone || ''}
                                                        >
                                                            <MenuItem value=""><em>None</em></MenuItem>
                                                            {postcodeZones.map((postcodeZone) => (
                                                                <MenuItem
                                                                    key={postcodeZone.postcodeZone}
                                                                    value={postcodeZone.postcodeZone}
                                                                    disabled={Object.keys(contact.contactEngineer.postcodeZones || {}).some((key) => contact.contactEngineer.postcodeZones[key].postcodeZone === postcodeZone.postcodeZone)}
                                                                >
                                                                    {postcodeZone.postcodeZone}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                        {errors.engineerPostcodeZone && (
                                                            <FormHelperText>{errors.engineerPostcodeZone}</FormHelperText>
                                                        )}
                                                    </FormControl>
                                                </Grid>
                                                <Grid
                                                    container
                                                    spacing={0}
                                                    direction="column"
                                                    alignItems="center"
                                                    justify="center"
                                                >
                                                    <Grid item xs={12}>
                                                        <Button
                                                            className={classes.dialogButton}
                                                            type="submit"
                                                            disabled={disableAddEngineerPostcodeZoneSaveButton || !addEngineerPostcodeZoneData.engineerPostcodeZone}
                                                            onClick={this.addEngineerPostcodeZone}
                                                        >
                                                            SAVE
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </>
                                        </div>
                                    </DialogContent>
                                    <Divider />
                                    <DialogActions className={classes.dialogActions}>
                                        <Button
                                            onClick={this.handleAddEngineerPostcodeZoneCloseDialogClick}
                                            color="primary"
                                            autoFocus
                                        >
                                            Close
                                        </Button>
                                    </DialogActions>
                                </Dialog>
                            </>

                        )
                        : (
                            <div className={classes.progressContainer}>
                                <CircularProgress className={classes.progress} variant="indeterminate" />
                            </div>
                        )}
                </Tile>
                <ContactHistory
                    addNewHistoryNote={addNewHistoryNote}
                    contact={contact}
                    contactHistoriesLoading={contactHistoriesLoading}
                    entryType="ENGINEER"
                    entryTypeReferenceCode={isEmpty(contact.contactEngineer) ? '' : `C${contact.code}`}
                    fetchHistoriesData={fetchHistoriesData}
                    histories={currentEngineerHistories}
                    tileTitlePostfix={isEmpty(contact.contactEngineer) ? '' : ` (C${contact.code})`}
                    errors={errors}
                />
            </>
        );
    }
}

// const formShape = {
//     title: PropTypes.string,
//     firstname: PropTypes.string,
//     surname: PropTypes.string,
//     fullName: PropTypes.string,
//     address1: PropTypes.string,
//     address2: PropTypes.string,
//     townCity: PropTypes.string,
//     county: PropTypes.string,
//     postcode: PropTypes.string,
//     country: PropTypes.string,
//     homeTelephoneNumber: PropTypes.string,
//     mobileTelephoneNumber: PropTypes.string,
//     emailAddress: PropTypes.string,
//     gdpr: PropTypes.number,
// };

// ContactDebt.propTypes = {
//     classes: PropTypes.object.isRequired,
//     contact: PropTypes.shape(formShape).isRequired,
//     errors: PropTypes.object.isRequired,
// };

export default withSnackbar(withStyles(styles)(ContactEngineer));
